import { useQuery } from '@tanstack/react-query';
import { Badge } from '../../../components/ui';
import { healthQuery, readinessQuery } from '../queries';
import { WidgetCard } from '../primitives';

/**
 * A quiet build/deployment status line. When everything is up it is a single
 * green sentence; when it is not, it says so plainly. It is deliberately not the
 * loudest thing on the screen — unlike the old dashboard, health is not the work.
 */
export function SystemStatusWidget() {
  const health = useQuery({ ...healthQuery, retry: 1 });
  const readiness = useQuery({ ...readinessQuery, retry: 1 });

  const apiOk = health.isSuccess;
  const dbOk = readiness.isSuccess && readiness.data.database === 'up';
  const ok = apiOk && dbOk;

  return (
    <WidgetCard title="System">
      <div className="flex flex-wrap items-center gap-2 text-sm">
        <Badge tone={ok ? 'green' : 'hazard'}>{ok ? 'Operational' : 'Attention'}</Badge>
        <span className="text-ink-body">
          API {apiOk ? `v${health.data.version}` : 'unreachable'} · database{' '}
          {dbOk ? 'up' : 'not ready'}
        </span>
      </div>
    </WidgetCard>
  );
}
